import { notification } from 'antd';
import { isAxiosError } from 'axios';
import i18n from 'translations/i18n';
import { makeHumanReadablePopupError } from './error.util';

export const notifySuccess = (key: string): void => {
  notification.success({
    message: i18n.t(key),
  });
};

export const notifyError = (key: string): void =>{
  notification.error({
    message: i18n.t(key),
  });
};

export const notifyErrorMessage = (
  error: any,
  message: string,
  description: string = '',
  findDescriptionText: string = '',
  isTransformString: boolean = false,
  maxLen: number = 132,
): void => {
  if (isAxiosError(error) && error.response?.data?.error) {
    if (error.response?.status === 400) {
      const errorMessage = error.response?.data?.error;
      let notificationDescription = '';

      if (findDescriptionText) {
        if (errorMessage.includes(findDescriptionText)) {
          notificationDescription = isTransformString
            ? makeHumanReadablePopupError(description, maxLen)
            : i18n.t(description);
        } else {
          notificationDescription = isTransformString
            ? makeHumanReadablePopupError(errorMessage, maxLen)
            : i18n.t(errorMessage);
        }
      } else {
        notificationDescription = isTransformString ? makeHumanReadablePopupError(errorMessage, maxLen) : errorMessage;
      }

      notification.error({
        message: i18n.t(message),
        description: notificationDescription,
        duration: 10,
      });
    }
  } else {
    notifyError(message);
  }
};
